import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "links" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_link_button = _resolveComponent("link-button")!
  const _component_link_text = _resolveComponent("link-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links, (link, i) => {
      return (_openBlock(), _createElementBlock(_Fragment, null, [
        (i === 0)
          ? (_openBlock(), _createBlock(_component_link_button, {
              text: link[0],
              href: link[1],
              bgColor: (!_ctx.themeColor && _ctx.textColor) ? _ctx.textColor : _ctx.themeColor,
              textColor: (!_ctx.themeColor && _ctx.textColor) ? '#fff' : _ctx.textColor,
              key: 'btn-' + i
            }, null, 8, ["text", "href", "bgColor", "textColor"]))
          : (_openBlock(), _createBlock(_component_link_text, {
              text: link[0],
              href: link[1],
              textColor: _ctx.themeColor || _ctx.textColor,
              key: 'txt-' + i
            }, null, 8, ["text", "href", "textColor"]))
      ], 64))
    }), 256))
  ]))
}